import { inject } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router"
import { switchMap } from "rxjs/operators"

import { FirebaseAuthService, UserService } from "@services"

export const authGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(FirebaseAuthService)
  const userService = inject(UserService)
  const router = inject(Router)

  return authService.isLoggedIn().pipe(
    switchMap(async (isLoggedIn) => {
      if (!isLoggedIn) {
        return router.parseUrl("/login")
      }

      // Heal accounts left broken by an interrupted registration (Auth user without Firestore
      // docs) before entering the app. Cheap for intact accounts and memoized per session; a
      // failure must not lock the user out, the app then just behaves as before.
      try {
        await userService.ensureCurrentUserProvisioned()
      } catch (err) {
        console.error("Failed to ensure the current user is provisioned:", err)
      }

      return true
    }),
  )
}
